import React from "react";
import {useSelector} from "react-redux";

import {CreateMatchForm, MatchView} from "../../containers";

const MatchPage = () => {
    const {showMainView} = useSelector(state => state.main);
    return (
        <div className="app-page">
            {showMainView ? <MatchView/> : <CreateMatchForm/>}
        </div>
    )
}

export default MatchPage